import React from 'react';
import './SitePlan.scss';
import ClubXianNotice from '../../../widgets/Xi/component/ClubXianNotice';
import 단지배치도 from '../../../shared/asset/Xi/단지배치도.jpg';

const SitePlan = () => {
  const notices = [
    '',
    '동 상부에 공용부 전기생산을 위한 태양광 집광판이 설치되며, 위치, 크기, 개소 등은 실 시공 시 변경될 수 있습니다. (동 배치, 일조량, 그늘 여부에 따라 일부동에 분산 설치됨)',
    '단지 외부의 주변도로, 공원 등은 현재 상황 또는 설치 계획을 보여주는 것으로 실제와 다를 수 있으며, 이는 시공사의 시공범위가 아닙니다.',
    '대지경계선과 구역경계선 사이의 부지는 기부채납 지역으로 시공사의 공사분이 아니며, 기부채납하는 공원, 주차장 등은 공공시설이므로 외부인이 사용할 수 있어, 계약 전 반드시 확인하시기 바라며 발생하는 민원에 대해서는 추후의 이의를 제기할 수 없습니다.',
    '단지 경계부 레벨 계획은 공사 진행현황에 따라 변경될 수 있으며, 그에 따라 경계부 단차 계획 등이 변경될 수 있습니다.',
    '[1단지] 지하 3층, 지하 2층 주차장은 전체 동에서 직접 출입이 가능하며, 지하 1층 주차장은 101, 102, 106~110, 115~117동에서는 직접 출입이 불가합니다.',
    '[2단지] 지하 3층~지하 1층 주차장은 전체 동에서 직접 출입이 가능합니다.',
    '1단지 지하 3층 주차장과 2단지 지하 2층 주차장은 연결통로로 연결되어 있으며 발생하는 관련비용 등 제반사항은 사업주체 및 입주자대표회의에서 결정됩니다.',
    '207동 전면으로 방음벽이 설치됩니다.',
    '관리사무소는 1단지와 2단지에 각각 설치됩니다.',
    '1단지 내 공공개방주차장은 외부인이 사용가능하며 임의로 막아 전유할 수 없습니다.',
    '104~107동과 109~112동 사이, 203,209동과 204,208동 사이 보행통로는 공공보행통로로 지정되어 외부인의 통행이 가능합니다.'
  ];

  return (
    <div className="sitePlan">
      <div className="main-content">
        <div className="image-section">
          <img src={단지배치도} alt="클럽클라우드1" />
        </div>
      </div>
      <ClubXianNotice notices={notices} />
    </div>
  );
};

export default SitePlan;